<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 32"
  >
    <g
      :fill="color"
      class="fill-current"
    >
      <path d="M12,6a6,6,0,1,0,6,6A6,6,0,0,0,12,6Zm0,10a4,4,0,1,1,4-4h0A4,4,0,0,1,12,16ZM12,0A12,12,0,0,0,0,12c0,4.84,1.69,6.19,10.77,19.35a1.48,1.48,0,0,0,2.46,0C22.31,18.19,24,16.84,24,12A12,12,0,0,0,12,0Zm0,29.62C3.29,17,2,16,2,12a10,10,0,0,1,20,0C22,16,20.71,17,12,29.62Z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
